<div class="bg-white mb-5 py-3">
  <div class="container-fluid">
    <div class="d-flex justify-content-between w-100">
      <strong class="pb-2 h5 d-block">Buscar por:</strong>
      <ng-content select="[add-button]"></ng-content>
    </div>
    <ng-content select="[content]"></ng-content>
  </div>
</div>
